<template>
  <div class="con-vs-loading">
    <div class="vs-loading corners" style="transform: scale(1);">
      <div class="effect-1 effects">
      </div>
      <div class="effect-2 effects"></div>
      <div class="effect-3 effects"></div>
      <img src="">
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
  .con-vs-loading{
    position: relative !important;
    transform: unset !important;
    top: unset !important;
    left: unset !important;
  }
</style>
